import React from 'react';
import { Route, Routes } from 'react-router';
import { useAtomValue } from 'jotai';

import { appConfigAtom } from '../shared/atoms/app-config/atom';

import { ErrorPage } from './pages/error-page';
import { MoneyPoolPage } from './pages/money-pool';
import { MoneyPoolQR } from './pages/money-pool-qr';

export const RouteSwitch = () => {
    const { contextRoot } = useAtomValue(appConfigAtom);

    return (
        <Routes>
            <Route path={`${contextRoot}/:publicId`}>
                <Route index={true} element={<MoneyPoolPage />} />
                <Route path='qr' element={<MoneyPoolQR />} />
            </Route>
            <Route path='*' element={<ErrorPage />} />
        </Routes>
    );
};
